import { query } from '@/services/graphql';
import * as operations from './operations';

export default {
  fetchStatistic(variables = {}) {
    return query(operations.GET_STATISTIC, variables, true);
  },
  fetchSpecificStatistic(variables = {}) {
    return query(operations.GET_SPECIFIC_STATISTIC, variables, true);
  },
  fetchRankList(variables = {}) {
    return query(operations.RANK_LIST, variables, true);
  },
  getExamRecords(variables = {}) {
    return query(operations.EXAM_RECORDS, variables, true);
  },
  getExamTypes(variables = {}) {
    return query(operations.EXAM_TYPES, variables, true);
  },
  getCourseReportLabelList(variables = {}) {
    return query(operations.COURSE_REPOER_LABEL_LIST, variables, true);
  },
};
